import { render, staticRenderFns } from "./Graficos.vue?vue&type=template&id=2d74e13f&"
import script from "./Graficos.vue?vue&type=script&lang=js&"
export * from "./Graficos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports